import Cookies from 'js-cookie'
import { publicWebApi } from 'PublicWebApi'
import { useDispatch } from 'react-redux'
import { useSliceDispatch, useSliceStateSelector } from 'slices/hooks'
import { LanguageState } from 'slices/Language/slice'
import { cookieName } from 'utils/cookies'

const useSelectedLanguage = () => {
  const isTranslationsEnabled = window.FEATURE_FLAGS.includes(
    'Public-Web-Frontend_enableEnglishTranslations_temp_250326'
  )
  const trigger = useSliceDispatch()
  const dispatch = useDispatch()

  const { selectedLanguage } = useSliceStateSelector(
    (state) => state.slices.language
  )

  const setSelectedLanguage = (language: LanguageState) => {
    if (isTranslationsEnabled) {
      Cookies.set(cookieName.trrLanguage, language, {
        expires: 180,
        secure: true,
      })

      trigger('setSelectedLanguage', language)
      dispatch(publicWebApi.util.invalidateTags(['Settings']))
      dispatch(publicWebApi.util.invalidateTags(['Content']))
    }
  }

  return {
    isTranslationsEnabled,
    selectedLanguage,
    setSelectedLanguage,
  }
}

export default useSelectedLanguage
